import {Button, styled} from '@mui/material';

export const EvoachButton: any = styled(Button) `border-radius: 4px 0 4px 0;`;